module.exports = __webpack_public_path__ + "static/media/locandaDaLino.8afb9017.jpg";